"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VRCConfigValidityT = exports.VRCConfigValidity = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class VRCConfigValidity {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsVRCConfigValidity(bb, obj) {
        return (obj || new VRCConfigValidity()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsVRCConfigValidity(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new VRCConfigValidity()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    legacyModeOk() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    shoulderTrackingOk() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    userHeightOk() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    calibrationRangeOk() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    calibrationVisualsOk() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    trackerModelOk() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    spineModeOk() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    avatarMeasurementTypeOk() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    shoulderWidthCompensationOk() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startVRCConfigValidity(builder) {
        builder.startObject(9);
    }
    static addLegacyModeOk(builder, legacyModeOk) {
        builder.addFieldInt8(0, +legacyModeOk, +false);
    }
    static addShoulderTrackingOk(builder, shoulderTrackingOk) {
        builder.addFieldInt8(1, +shoulderTrackingOk, +false);
    }
    static addUserHeightOk(builder, userHeightOk) {
        builder.addFieldInt8(2, +userHeightOk, +false);
    }
    static addCalibrationRangeOk(builder, calibrationRangeOk) {
        builder.addFieldInt8(3, +calibrationRangeOk, +false);
    }
    static addCalibrationVisualsOk(builder, calibrationVisualsOk) {
        builder.addFieldInt8(4, +calibrationVisualsOk, +false);
    }
    static addTrackerModelOk(builder, trackerModelOk) {
        builder.addFieldInt8(5, +trackerModelOk, +false);
    }
    static addSpineModeOk(builder, spineModeOk) {
        builder.addFieldInt8(6, +spineModeOk, +false);
    }
    static addAvatarMeasurementTypeOk(builder, avatarMeasurementTypeOk) {
        builder.addFieldInt8(7, +avatarMeasurementTypeOk, +false);
    }
    static addShoulderWidthCompensationOk(builder, shoulderWidthCompensationOk) {
        builder.addFieldInt8(8, +shoulderWidthCompensationOk, +false);
    }
    static endVRCConfigValidity(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createVRCConfigValidity(builder, legacyModeOk, shoulderTrackingOk, userHeightOk, calibrationRangeOk, calibrationVisualsOk, trackerModelOk, spineModeOk, avatarMeasurementTypeOk, shoulderWidthCompensationOk) {
        VRCConfigValidity.startVRCConfigValidity(builder);
        VRCConfigValidity.addLegacyModeOk(builder, legacyModeOk);
        VRCConfigValidity.addShoulderTrackingOk(builder, shoulderTrackingOk);
        VRCConfigValidity.addUserHeightOk(builder, userHeightOk);
        VRCConfigValidity.addCalibrationRangeOk(builder, calibrationRangeOk);
        VRCConfigValidity.addCalibrationVisualsOk(builder, calibrationVisualsOk);
        VRCConfigValidity.addTrackerModelOk(builder, trackerModelOk);
        VRCConfigValidity.addSpineModeOk(builder, spineModeOk);
        VRCConfigValidity.addAvatarMeasurementTypeOk(builder, avatarMeasurementTypeOk);
        VRCConfigValidity.addShoulderWidthCompensationOk(builder, shoulderWidthCompensationOk);
        return VRCConfigValidity.endVRCConfigValidity(builder);
    }
    unpack() {
        return new VRCConfigValidityT(this.legacyModeOk(), this.shoulderTrackingOk(), this.userHeightOk(), this.calibrationRangeOk(), this.calibrationVisualsOk(), this.trackerModelOk(), this.spineModeOk(), this.avatarMeasurementTypeOk(), this.shoulderWidthCompensationOk());
    }
    unpackTo(_o) {
        _o.legacyModeOk = this.legacyModeOk();
        _o.shoulderTrackingOk = this.shoulderTrackingOk();
        _o.userHeightOk = this.userHeightOk();
        _o.calibrationRangeOk = this.calibrationRangeOk();
        _o.calibrationVisualsOk = this.calibrationVisualsOk();
        _o.trackerModelOk = this.trackerModelOk();
        _o.spineModeOk = this.spineModeOk();
        _o.avatarMeasurementTypeOk = this.avatarMeasurementTypeOk();
        _o.shoulderWidthCompensationOk = this.shoulderWidthCompensationOk();
    }
}
exports.VRCConfigValidity = VRCConfigValidity;
class VRCConfigValidityT {
    constructor(legacyModeOk = false, shoulderTrackingOk = false, userHeightOk = false, calibrationRangeOk = false, calibrationVisualsOk = false, trackerModelOk = false, spineModeOk = false, avatarMeasurementTypeOk = false, shoulderWidthCompensationOk = false) {
        this.legacyModeOk = legacyModeOk;
        this.shoulderTrackingOk = shoulderTrackingOk;
        this.userHeightOk = userHeightOk;
        this.calibrationRangeOk = calibrationRangeOk;
        this.calibrationVisualsOk = calibrationVisualsOk;
        this.trackerModelOk = trackerModelOk;
        this.spineModeOk = spineModeOk;
        this.avatarMeasurementTypeOk = avatarMeasurementTypeOk;
        this.shoulderWidthCompensationOk = shoulderWidthCompensationOk;
    }
    pack(builder) {
        return VRCConfigValidity.createVRCConfigValidity(builder, this.legacyModeOk, this.shoulderTrackingOk, this.userHeightOk, this.calibrationRangeOk, this.calibrationVisualsOk, this.trackerModelOk, this.spineModeOk, this.avatarMeasurementTypeOk, this.shoulderWidthCompensationOk);
    }
}
exports.VRCConfigValidityT = VRCConfigValidityT;
